import logo from "../../images/p4.png"


export default function P4() {
  return (
    <img className="p" src={logo} alt="contact logo" />
   
  );
}